import RestaurantConfig from "./RestaurantConfig";
import AuthService from "../auth/AuthService"
import Setting from "../base/Settings"
export default class RestaurantService {

  /******* RESTAURANTS **********/
  static onChangeOrders(restaurantId, callback) {
    return RestaurantConfig.FirestoreConnector.onChangeOrderQuery(restaurantId, callback)
  }

  static getRestaurants(app) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointRestaurants;
        let response = await RestaurantConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static saveRestaurant(app,restaurant, isCopyWithTickets, userId) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointSaveRestaurant;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurant:restaurant, isCopyWithTickets:isCopyWithTickets, userId:userId})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static deleteRestaurant(app,restaurantId) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointDeleteRestaurant;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({id:restaurantId})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static getDynamicAppLink(restoId, table){
    return new Promise(async (resolve, reject) => {
      try{
        const endpoint = RestaurantConfig.endpointDynamicAppLink
        const data = Setting.DYNAMIC_LINK_DATA
        //CODE RESTO ID
        const middle = Math.floor(restoId.length/2)
        let idCommerce = restoId.slice(middle, restoId.length) + restoId.slice(0,middle)
        
        //CODE table
        const tStr = (""+table).trim()
        let t = ""
        for(let i = 0;i<tStr.length;i++){
          let coef = parseInt(tStr[i])+1
          if(coef>5){
            for(let k=0;k<coef-5;k++){
              t+= String.fromCharCode(65+Math.random()*(90-65))//Pongo una letra mayúscula
            }
          }else{
            for(let k=0;k<coef;k++){
              t+= String.fromCharCode(97+Math.random()*(122-97))//Pongo una letra minúscula
            }          
          }
          t+=Math.trunc(Math.random()*10)
        }
        //DECODE RESTO ID
        // const middle2 = Math.ceil(idCommerce.length/2)
        // const uidCommerce = idCommerce.slice(middle2, idCommerce.length) + idCommerce.slice(0,middle2)
        // //DECODE TABLE
        // const tArr = t.split(/[0-9]/g)
        // let utStr = ""
        // for(let i = 0;i<tArr.length;i++){
        //   let l = tArr[i].length
        //   if(l>0){
        //     if(tArr[i].match(/[A-Z]/g)){
        //       l+=5
        //     }
        //     utStr+=(l-1)
        //   }
        // }
        // const ut = parseInt(utStr)
        // console.log("ORIGINAL", restoId, table)  
        // console.log("CODE", t, idCommerce)
        // console.log("DECODE", ut, uidCommerce)
          
        const body = 
        { 
          dynamicLinkInfo: {
            domainUriPrefix: data.domainPrefix,
            link: `${data.linkDomain}?idCommerce=${idCommerce}&table=${t}`
            // , androidInfo: {
            //   androidPackageName: data.androidPkg
            // }
            // ,
            // iosInfo: {
            //   iosBundleId: data.iosPkg
            // }
          }
        }
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
          body: JSON.stringify(body)
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
  /******** FIN RESTAURANTS *********/
  /******** MENU CATEGORIES **********/  
  static getMenuCategoriesByRestaurant(app, restaurantId) {

    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpoinMenuCategories;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify({id:restaurantId})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static saveMenuCategory(app,restaurantId, category) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpoinSaveMenuCategories;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId, category:category})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static deleteMenuCategory(app,restaurantId, categoryId) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointDeleteMenuCategory;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId, categoryId:categoryId})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
  /******** TICKET TYPES **********/
  static getTicketTypesByRestaurant(app, restaurantId) {
    
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointTicketTypes;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify({id:restaurantId})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static saveTicketType(app,restaurantId, ticketType, userId) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointSaveTicketType;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId, ticketType:ticketType, userId:userId})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static updateMenu(app, restaurantId, menuId, menu) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointUpdateMenu;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId, menu:menu, menuId:menuId})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static deleteTicketType(app,restaurantId, ticketTypeId) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointDeleteTicketType;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId, ticketTypeId:ticketTypeId})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  // static getCategories(app) {
    
  //   return new Promise(async (resolve, reject) => {
  //     try{
        
  //       let token = await AuthService.getToken()
  //       let endpoint = RestaurantConfig.endpointCategories;
  //       let response = await RestaurantConfig.APIConnector.get(endpoint, {
  //           headers: { Authorization: "Bearer " + token, App:app },
  //       });
  //       if(response.status==200){
  //         resolve(response.body)
  //       }else{
  //         reject(response)
  //       }
  //     }catch(e){
  //       reject(e)
  //     }
  //   });
  // }
  /******* FIN TICKET TYPES**********/
  /******** TICKETS **********/
  static getTicketsByRestaurant(app, restaurantId, filter) {
      
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointOrders;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify({id:restaurantId, filter:filter})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static sendOrderToCook(app, restaurantId, order) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointOrderToCook;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId, order:order})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static readyToDeliver(app, restaurantId, order) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointReadyToDeliver;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId, order:order})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static deliverOrder(app, restaurantId, order) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointDeliverOrder;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId, order:order})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static saveTickets(app, restaurantId, tickets, rrppId, origin) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointSaveTickets;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId, tickets:tickets, rrppId:rrppId, origin:origin})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static deleteTicket(app,restaurantId, ticketId, du) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointDeleteTicket;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId, ticketId:ticketId, du:du})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static registerOrderListener(app, resId, userId, msgToken){
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointRegisterOrderListener;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({resId:resId, userId:userId, msgToken:msgToken})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static deleteOrderListener(app, resId, userId, msgToken){
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointDeleteOrderListener;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({resId:resId, userId:userId, msgToken:msgToken})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  
  /******* FIN TICKET **********/
  /******* STATISTICS **********/
  static getStatistics(app, restaurantId) {
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointStatistics;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static getStatisticsRRPP(app, restaurantId) {
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointStatisticsRRPP
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  /******* FIN STATISTICS **********/
  /******** RESERVATIONS **********/
  static getReservations(app, restaurantId, filter) {
    return new Promise(async (resolve, reject) => {
      try{     
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointReservations;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify({id:restaurantId, filter:filter})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static saveReservationState(app, restaurant, booking) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointSaveReservationState;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurant:restaurant, booking:booking})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static onChangeReservations(restaurantId, callback) {
    return RestaurantConfig.FirestoreConnector.onChangeReservationsQuery(restaurantId, callback)
  }
/******** FIN RESERVATIONS **********/
/******** DDJJ **********/
  static getDDJJByTable(app, restaurantId, filter) {
    return new Promise(async (resolve, reject) => {
      try{     
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointDDJJByTable;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify({id:restaurantId, filter:filter})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static getDDJJ(app, restaurantId, filter) {
    return new Promise(async (resolve, reject) => {
      try{     
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointDDJJ;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify({id:restaurantId, filter:filter})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static controlDDJJ(app, restaurantId, ddjj) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = RestaurantConfig.endpointControlDDJJ;
        let response = await RestaurantConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({restaurantId:restaurantId, ddjj:ddjj})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static onChangeDDJJ(restaurantId, callback) {
    return RestaurantConfig.FirestoreConnector.onChangeDDJJQuery(restaurantId, callback)
}
/******** FIN DDJJ **********/
}



// WEBPACK FOOTER //
// ./src/provider/restaurant/RestaurantService.js